import { render } from "./materialHome.vue?vue&type=template&id=610a95d1&scoped=true"
import script from "./materialHome.vue?vue&type=script&lang=js"
export * from "./materialHome.vue?vue&type=script&lang=js"

import "./materialHome.vue?vue&type=style&index=0&id=610a95d1&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-610a95d1"]])

export default __exports__